import React from 'react';

const { employerProfileSectionTitles } = require('buyside/util/constantsFromRails.json');

import PersonWithBriefcaseIcon from 'buyside/svgs/person_with_briefcase.svg';
import PersonWithSpeechBubbleIcon from 'buyside/svgs/person_with_speech_bubble.svg';
import StarIcon from 'buyside/svgs/star.svg';
import TagIcon from 'buyside/svgs/tag.svg';
import ChartArrowUpIcon from 'buyside/svgs/chart_arrow_up.svg';
import PenAndPaperIcon from 'buyside/svgs/pen_and_paper.svg';
import PersonWithFlagIcon from 'buyside/svgs/person_with_flag.svg';
import RadioTowerIcon from 'buyside/svgs/radio_tower.svg';
import NewspaperFoldIcon from 'buyside/svgs/newspaper_fold.svg';
import RulerIcon from 'buyside/svgs/ruler.svg';
import PieChartWithDollarSignIcon from 'buyside/svgs/pie_chart_with_dollar_sign.svg';
import MagnifyingGlassWithCheckIcon from 'buyside/svgs/magnifying_glass_with_check.svg';
import NotesWithPaperclipIcon from 'buyside/svgs/notes_with_paperclip.svg';

import SubmitResearchButton from 'buyside/components/presentation/Button/SubmitResearchButton/submitResearchButton';

import ExecutiveManagement from 'buyside/components/presentation/FundProfileShowPage/FundProfileSection/ExecutiveManagement/executiveManagement';
import FirmReferences from 'buyside/components/presentation/FundProfileShowPage/FundProfileSection/FirmReferences/firmReferences';
import Expertise from 'buyside/components/presentation/FundProfileShowPage/FundProfileSection/Expertise/expertise';
import Tags from 'buyside/components/presentation/FundProfileShowPage/FundProfileSection/Tags/tags';
import Returns from 'buyside/components/presentation/FundProfileShowPage/FundProfileSection/Returns/returns';
import FeaturedResearch from 'buyside/components/presentation/FundProfileShowPage/FundProfileSection/FeaturedResearch/featuredResearch';
import FundHoldings from 'buyside/components/presentation/FundProfileShowPage/FundProfileSection/FundHoldings/fundHoldings';
import MarketingMaterials from 'buyside/components/presentation/FundProfileShowPage/FundProfileSection/MarketingMaterials/marketingMaterials';
import PressMedia from 'buyside/components/presentation/FundProfileShowPage/FundProfileSection/PressMedia/pressMedia';
import Metrics from 'buyside/components/presentation/FundProfileShowPage/FundProfileSection/Metrics/metrics';
import FeeStructure from 'buyside/components/presentation/FundProfileShowPage/FundProfileSection/FeeStructure/feeStructure';
import DueDiligence from 'buyside/components/presentation/FundProfileShowPage/FundProfileSection/DueDiligence/dueDiligence';
import Notes from 'buyside/components/presentation/FundProfileShowPage/FundProfileSection/Notes/notes';

import ExecutiveManagementForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/ExecutiveManagementForm/executiveManagementForm';
import FirmReferencesForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/FirmReferencesForm/firmReferencesForm';
import FirmReferencesReorderForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/FirmReferencesReorderForm/firmReferencesReorderForm';
import ExpertiseForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/ExpertiseForm/expertiseForm';
import TagsForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/TagsForm/tagsForm';
import ReturnsForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/ReturnsForm/returnsForm';
import FeaturedResearchReorderForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/FeaturedResearchReorderForm/featuredResearchReorderForm';
import FundHoldingsForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/FundHoldingsForm/fundHoldingsForm';
import MarketingMaterialsForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/MarketingMaterialsForm/marketingMaterialsForm';
import MarketingMaterialsReorderForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/MarketingMaterialsReorderForm/marketingMaterialsReorderForm';
import PressMediaForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/PressMediaForm/pressMediaForm';
import PressMediaReorderForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/PressMediaReorderForm/pressMediaReorderForm';
import MetricsForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/MetricsForm/metricsForm';
import FeeStructureForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/FeeStructureForm/feeStructureForm';
import DueDiligenceForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/DueDiligenceForm/dueDiligenceForm';
import NotesForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/NotesForm/notesForm';

import {
  executiveManagementSchema,
  firmReferencesSchema,
  expertiseSchema,
  returnsSchema,
  fundHoldingsSchema,
  marketingMaterialsSchema,
  pressMediaSchema,
  metricsSchema,
  feeStructureSchema,
  dueDiligenceSchema
} from 'buyside/util/fundProfileShowPageValidationSchemata';

export const SECTIONS = Object.keys(employerProfileSectionTitles);

export const ICONS = {
  executive_management: PersonWithBriefcaseIcon,
  firm_references: PersonWithSpeechBubbleIcon,
  expertise: StarIcon,
  tags: TagIcon,
  returns: ChartArrowUpIcon,
  research: PenAndPaperIcon,
  holdings: PersonWithFlagIcon,
  marketing_materials: PenAndPaperIcon,
  press: NewspaperFoldIcon,
  metrics: RulerIcon,
  fee_structure: PieChartWithDollarSignIcon,
  due_diligence: MagnifyingGlassWithCheckIcon,
  notes: NotesWithPaperclipIcon
};

export const TITLES = employerProfileSectionTitles;

export const TIPS = {
  executive_management: 'Add at least 1 senior management bio with at least 500 characters of text',
  firm_references: 'Add at least 2 complete personal or professional refererences',
  expertise: 'Add at least 1 expertise area in each category',
  tags: 'Add at least 1 operational characteristic tag from each category',
  returns: 'Add at least 2 net annualized return datapoints or returns documents',
  research: 'Add at least 3 posted research ideas (and 1 within the last 6 months)',
  holdings: 'Add at least 2 current fund holdings or holdings documents',
  marketing_materials: 'Add at least 2 Investor Letters, 1 Marketing Presentation, and 1 Tearsheet',
  press: 'Add at least 2 Press/Media items',
  metrics:
    "Add your fund's historical Sharpe Ratio, Beta, and Turnover Ratio, or 3 metrics documents",
  fee_structure:
    "Add your fund's Management Fee, Incentive Fee, and one of the Yes/No items, or a fee structure document",
  due_diligence: 'Add all required document types and service providers'
};

export const MINIMUM_ATTRIBUTES = {
  executive_management: ['executives'],
  firm_references: ['firmReferences'],
  expertise: [
    'sectorExpertise',
    'geographicExpertise',
    'assetClassExpertise',
    'subsectorExpertise'
  ],
  tags: ['tagNames'],
  returns: ['returnsUpdatedDate', 'returnsDocuments'],
  research: ['featuredResearch', 'featuredWhitePaperResearch'],
  holdings: ['holdings', 'holdingsDocuments'],
  marketing_materials: ['marketingMaterials'],
  press: ['presses'],
  metrics: ['sharpeRatio', 'beta', 'turnoverRatio', 'metricsDocuments'],
  fee_structure: ['id'],
  due_diligence: ['dueDiligenceDocuments', 'serviceProviders'],
  notes: ['notes']
};

export const EMPTY_TEXT = {
  research: (
    <div>
      <p>
        No Research Posted. Click the "Submit Research" button to submit new research and increase
        your fund's Completeness Score.
      </p>
      <p>
        Your research ideas are the #1 driver of allocator traffic to your page, and are integral
        elements in their vetting process. Once accepted by SumZero, your research will
        automatically append to this page. Submit research that serves as a strong representation of
        your fund's strategy/investment process.
      </p>
      <div>
        <SubmitResearchButton />
      </div>
    </div>
  ),
  notes: <div>Section Empty. Click the "Edit" button to add information.</div>,
  default: (
    <div>
      <p>
        Section Empty. Click the "Edit" button to add information and increase your fund's
        Completeness Score.
      </p>
      <div>
        Funds with higher Completeness Scores receive prioritization in search results, earn
        stronger visual distinction, and ultimately derive more page traffic from allocators versus
        funds with lower scores.
      </div>
    </div>
  )
};

export const COMPONENTS = {
  executive_management: ExecutiveManagement,
  firm_references: FirmReferences,
  expertise: Expertise,
  tags: Tags,
  returns: Returns,
  research: FeaturedResearch,
  holdings: FundHoldings,
  marketing_materials: MarketingMaterials,
  press: PressMedia,
  metrics: Metrics,
  fee_structure: FeeStructure,
  due_diligence: DueDiligence,
  notes: Notes
};

export const EDIT_FORMS = {
  executive_management: ExecutiveManagementForm,
  firm_references: FirmReferencesForm,
  expertise: ExpertiseForm,
  tags: TagsForm,
  returns: ReturnsForm,
  holdings: FundHoldingsForm,
  marketing_materials: MarketingMaterialsForm,
  press: PressMediaForm,
  metrics: MetricsForm,
  fee_structure: FeeStructureForm,
  due_diligence: DueDiligenceForm,
  notes: NotesForm
};

export const EDIT_FORM_BOX_TEXT = {
  executive_management:
    'Add at least 1 senior management bio with at least 500 characters of text to get the full award for this section.',
  firm_references:
    'Add at least 2 complete personal or professional references that can speak to the integrity of the people behind your firm to get the full award for this section. Do not include service providers in this section; they will be removed as references.',
  expertise:
    'Add at least 1 expertise area in each category to get the full award for this section. Add as many as apply. These datapoints are critical inputs in matching your fund with prospective allocators. The more relevance you add, the stronger our ability to match your fund will become.',
  tags:
    'Add at least 1 operational characteristic tag from each category to get the full award for this section. Add as many as apply. These datapoints are critical inputs in matching your fund with prospective allocators. The more relevance you add, the stronger our ability to match your fund will become.',
  returns:
    "Add at least 2 net annualized return datapoints or returns documents to get the full award for this section. <strong>Input only annualized figures, net of all fees in each section.</strong> LTM is last twelve calendar months. 1 Year, 3 Year, 5 Year, 7 Year, and 10 Year returns should be calculated according to your firm's specific reporting periods (LTM and 1-Year are occasionally identical). Full month-by-month performance breakdowns (and additional performance supplements) may be attached as supporting documents below.",
  holdings:
    "Add at least 2 current fund holdings or holdings documents to get the full award for this section. Holdings should highlight key positions in the firm's strategy and offer prospective investors an accurate representation of your current exposures. Additional position information may be attached as a supporting document below. Email support@sumzero.com if you need to add a ticker that is not available from our search.",
  marketing_materials:
    'Add at least 2 Investor Letters, 1 Marketing Presentation, and 1 Tearsheet to get the full award for this section. Materials in this section are heavily consumed by allocators, and are key aspects of the manager selection process. More documents tend to drive higher volumes of clicks, so add as many as you have. Additional document types (whitepapers, case studies, etc.) can also be hosted in this section.',
  press:
    'Add at least 2 Press/Media items to get the full award for this section. Articles can be added as website hyperlinks or as uploaded PDFs.',
  metrics:
    "Add your fund's historical Sharpe Ratio, Beta, and Turnover Ratio metrics, or 3 metrics documents, to get the full award for this section. These metrics are important search/filtering criteria for allocators. Additional key metric information may be attached as a supporting document below.",
  fee_structure:
    "Add your fund's Management Fee, Incentive Fee, and at least one of the Yes/No items, or a fee structure document, to get the full award for this section. Unique fee terms and situations may be attached as a supporting document below.",
  due_diligence:
    "Add your fund's DDQ, PPM, and Subscription Agreement into the Documents section, as well as your Administrator, Legal Counsel, Auditor, Custodian, and Prime Broker details to get the full award for this section.",
  notes:
    'Have we missed something important? Add any notable information here about your fund that is not properly captured in any of the above sections.'
};

export const REORDER_FORMS = {
  firm_references: FirmReferencesReorderForm,
  research: FeaturedResearchReorderForm,
  marketing_materials: MarketingMaterialsReorderForm,
  press: PressMediaReorderForm
};

export const REORDER_FORM_BOX_TEXT = {
  firm_references:
    'Click and drag firm references to change the order in which they are displayed.',
  research:
    'Click and drag research items to change the order in which they are displayed. Items will be displayed alternating left and right.',
  marketing_materials:
    'Click and drag supporting documents to change the order in which they are displayed.',
  press: 'Click and drag press items to change the order in which they are displayed.'
};

export const VALIDATION_SCHEMATA = {
  executive_management: executiveManagementSchema,
  firm_references: firmReferencesSchema,
  expertise: expertiseSchema,
  returns: returnsSchema,
  holdings: fundHoldingsSchema,
  marketing_materials: marketingMaterialsSchema,
  press: pressMediaSchema,
  metrics: metricsSchema,
  fee_structure: feeStructureSchema,
  due_diligence: dueDiligenceSchema
};

export const COMMUNITY = 'general_community_member';
export const ALLOCATOR = 'capital_allocator';
export const FILTERED_ALLOCATOR = 'filtered_allocator';
export const ADMIN = 'admin';
